import type { Hit, LedgerEntry, LedgerSummary } from '../../types';

export const initialState = {
  hits: [] as Hit[],
  isLoadingHits: false,
  hitsError: null as string | null,
  ledgerEntries: [] as LedgerEntry[],
  ledgerSummary: null as LedgerSummary | null,
  isLoadingLedger: false,
  ledgerError: null as string | null,
  boardId: null as string | null,
};
